import * as constants from "../constants.js";
import notifications from "../notifications";


export default {
    OnSuccess(description) {
        notifications.Success("Alertas", description);
    },

    OnError(resp, description) {
        notifications.Error("Alertas", description);
        console.log(resp);
    },

    OnUnauthorized(){
        window.location = "/";
    },
    
    GetAlertsPage: async function (size, num, orderDirection, searchTerm) {
        let reqUri = `${constants.API_ENDPOINT_ALERTS}/${size}/${num}`;
        let reqUriParams = `orderDirection=${orderDirection}&searchTerm=${encodeURI(searchTerm)}`;
        let result = await fetch(`${reqUri}?${reqUriParams}`, { 
                            method: constants.HTTP_METHOD_GET 
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao carregar os Alertas");
                                    return null;
                                }
                                if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                }
                            }

                            return resp.json();
                        });

        return result;
    },
    
    ReadAlerts: async function (formData) {
        let reqUri = `${constants.API_ENDPOINT_ALERTS}/read`;
        let result = await fetch(reqUri, { 
                            method: constants.HTTP_METHOD_PUT,
                            headers: constants.HTTP_HEADERS_JSON,
                            body: JSON.stringify(formData)
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao ler o Alerta");
                                    return null;
                                }
                                if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                }
                            }

                            return resp.json();
                        });

        return result;
    },
    
    RemoveAlert: async function (formData, showNotification) {
        let reqUri = `${constants.API_ENDPOINT_ALERTS}/remove`;
        let result = await fetch(reqUri, { 
                            method: constants.HTTP_METHOD_PUT,
                            headers: constants.HTTP_HEADERS_JSON,
                            body: JSON.stringify(formData)
                        })
                        .then(resp => {
                            if (!resp.ok) {
                                if (resp.status >= 500) {
                                    this.OnError(resp, "Ocorreu uma anomalia ao eliminar o Alerta");
                                    return null;
                                }
                                if(resp.status == 401){
                                    this.OnUnauthorized();
                                    return null;
                                }
                            } else {
                                if (resp.status == 200) {
                                    if (showNotification == null || showNotification)
                                        this.OnSuccess("Alerta eliminado com sucesso");
                                }
                            }

                            return resp.json();
                        });

        return result;
    },

    RemoveAlerts: async function (formData) {
        let reqUri = `${constants.API_ENDPOINT_ALERTS}/remove`;
        let result = await fetch(reqUri, { 
                        method: constants.HTTP_METHOD_PUT,
                        headers: constants.HTTP_HEADERS_JSON,
                        body: JSON.stringify(formData)
                    })
                    .then(resp => {
                        if (!resp.ok) {
                            if (resp.status >= 500) {
                                this.OnError(resp, "Ocorreu uma anomalia ao eliminar os Alertas");
                                return null;
                            }
                            if(resp.status == 401){
                                this.OnUnauthorized();
                                return null;
                            }
                        } else {
                            if (resp.status == 200) {
                                this.OnSuccess("Alertas eliminados com sucesso");
                            }
                        }

                        return resp.json();
                    });

        return result;
    },
    
    CountAlerts: async function () {
        let reqUri = `${constants.API_ENDPOINT_ALERTS}/count`;
        let result = await fetch(reqUri, { 
                        method: constants.HTTP_METHOD_GET 
                    })
                    .then(resp => {
                        if (!resp.ok) {
                            if (resp.status >= 500) {
                                this.OnError(resp, "Ocorreu uma anomalia ao contabilizar os Alertas");
                                return null;
                            }
                        }

                        return resp.json();
                    });

        return result;
    }
}
